import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function CreativeIcon({ size = 20, color = "white", className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M6.45833 2.9165C4.2725 2.9165 2.5 4.79984 2.5 7.12234C2.5 11.7707 10 17.0832 10 17.0832C10 17.0832 17.5 11.7707 17.5 7.12234C17.5 4.24484 15.7275 2.9165 13.5417 2.9165C11.9917 2.9165 10.65 3.86317 10 5.2415C9.35 3.86317 8.00833 2.9165 6.45833 2.9165Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 12.9165C12.5 9.69904 7.5 9.69904 7.5 12.9165" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.9987 10.4163C10.4407 10.4163 10.8646 10.2407 11.1772 9.92819C11.4898 9.61562 11.6654 9.1917 11.6654 8.74967C11.6654 8.30765 11.4898 7.88372 11.1772 7.57116C10.8646 7.2586 10.4407 7.08301 9.9987 7.08301C9.55667 7.08301 9.13275 7.2586 8.82019 7.57116C8.50763 7.88372 8.33203 8.30765 8.33203 8.74967C8.33203 9.1917 8.50763 9.61562 8.82019 9.92819C9.13275 10.2407 9.55667 10.4163 9.9987 10.4163Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
